import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import NotificationContext from '../../context/NotificationContext';
import AuthContext from '../../context/AuthContext';
import { getNotificationDestination } from '../../utils/notificationNavigation';
import { getNotificationIcon } from '../mainlayout/navbar/NavbarNotifications';
import { transformIframes } from '../../utils/utils';
import styles from './styles/NotificationToaster.module.css';

// Kill switch for the whole toast layer.
const NOTIFICATION_TOASTS_ENABLED = true;

/**
 * Auto-dismissing toasts for notifications arriving in real time. Rendered by
 * MainLayout only on pages WITHOUT the navbar (where the bell badge can't
 * signal). Click navigates like the dropdown items; invites just open nothing
 * (they need the Accept/Ignore buttons in the bell dropdown).
 */
const NotificationToaster = () => {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);
    const { toasts, dismissToast, markAsSeen } = useContext(NotificationContext);

    if (!NOTIFICATION_TOASTS_ENABLED || toasts.length === 0) {
        return null;
    }

    const handleToastClick = (toast) => {
        const { notification } = toast;
        if (notification._id && !notification.seen) {
            markAsSeen(notification._id).catch((err) =>
                console.error('Error marking notification as seen:', err)
            );
        }
        const destination = getNotificationDestination(notification, user?.username);
        if (destination) {
            navigate(destination.path, destination.state ? { state: destination.state } : undefined);
        }
        dismissToast(toast.id);
    };

    return (
        <div className={styles.toastStack} role="status" aria-live="polite">
            {toasts.map((toast) => (
                <div
                    key={toast.id}
                    className={styles.toast}
                    onClick={() => handleToastClick(toast)}
                >
                    <div className={styles.iconContainer}>
                        <FontAwesomeIcon
                            icon={getNotificationIcon(toast.notification.notificationType)}
                            className={styles.notificationIcon}
                        />
                    </div>
                    <p
                        className={styles.message}
                        dangerouslySetInnerHTML={{
                            __html: transformIframes(toast.notification.message)
                        }}
                    />
                    <button
                        className={styles.closeButton}
                        aria-label="Dismiss notification"
                        onClick={(e) => {
                            e.stopPropagation();
                            dismissToast(toast.id);
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default NotificationToaster;
